import React from 'react';
import { Card as AntdCard, CardProps } from 'antd';
import styled from '@emotion/styled';

const StyledCard = styled(AntdCard)``;
const Card = (props: CardProps) => {
  return <StyledCard {...props} />;
};

Card.Grid = AntdCard.Grid;
Card.Meta = AntdCard.Meta;

export default Card;
